module.exports = "h3 {\n    font-family: \"Raleway\" !important;\n    border-bottom: 1px solid #ccc9c9;\n    padding-bottom: 15px;\n    padding-right: 10px;\n    padding-left: 10px;\n    margin-bottom: 20px;\n    font-size: 18px;\n    font-weight: 300;\n}\n\n.barraArbolBase {\n    position: -webkit-sticky;\n    position: sticky;\n    top: 60px;\n}\n\n.informacionArbol {\n    height: calc(100vh - 60px);\n}\n\n.barraArbolBaseOcultar {\n    margin-top: 88px !important;\n}"


//////////////////
// WEBPACK FOOTER
// ./app/actividades/actividades.component.css
// module id = 1002
// module chunks = 0